import { isValidPhoneNumber } from 'libphonenumber-js';

export const validatePhoneNumber = (value, countryCode = 'FR') => {
    return isValidPhoneNumber(value, countryCode);
};
